import { PUBLIC_BASE_URL, GAME_ID } from '@config/game.js'
import { STATUS_ACCEPTED } from '@config/options.js'
import { queryString } from '@helpers/utils.js'
import { createClient } from '@services'

const { get } = createClient()

/* API request to get guides for game */
export async function getGuidesForGameRequest(queries) {
  const query = { ...queries }
  if (!query['status-in']) {
    query.status = STATUS_ACCEPTED
  }

  const { data } = await get(
    `${PUBLIC_BASE_URL}/games/${GAME_ID}/guides${queryString(query)}`
  )

  return data
}

/* API request to get guide */
export async function getGuideRequest(guideNameId) {
  const { data } = await get(
    `${PUBLIC_BASE_URL}/games/${GAME_ID}/guides/@${guideNameId}`
  )
  return data
}

/* API request to get guide tags */
export async function getGuideTagsRequest() {
  const { data } = await get(`${PUBLIC_BASE_URL}/games/${GAME_ID}/guides/tags`)
  return data
}
